import React, { useRef, useState } from "react";
import PlayWithCircle from "../../../../../components/Images/PlayWithCircle";
import { Box } from "../../../../../designSystem";
import CircularProgressBar from "../../ChapterAddEdit/VoiceSelection/circularProgressBar";
import { PlayPauseBtn } from "../../ChapterAddEdit/VoiceSelection/styles";

const AudioModule = ({ audioUrl }) => {
    const [angle, setAngle] = useState(0)
    const audioRef = useRef(null)
    const handlePlayPause = () => {
        const audio = audioRef.current;
        if (audio.paused) {
            audio.play();
        } else {
            audio.pause();
        }
    }

    const handleAudioTimeUpdate = (event) => {
        if(event.target.currentTime === event.target.duration)
        {
            event.target.currentTime = 0;
            event.target.pause();
        }else{
            setAngle((event.target.currentTime / event.target.duration) * 360)
        }
    }
    return(
        <Box>
            <audio 
                ref={audioRef}
                onTimeUpdate={handleAudioTimeUpdate}
            >
                <source 
                    src={audioUrl || 'http://dbj64m8271a9g.cloudfront.net/2225073ac0deaee26ef4552de090274570955e29_FjJz9EsztH.mp3'} 
                    type="audio/mp3" 
                />
            </audio>
            {(audioRef.current?.paused || !audioRef.current) ? 
                <PlayPauseBtn onClick={() => handlePlayPause()}>
                    <PlayWithCircle />
                </PlayPauseBtn>
            : 
            <PlayPauseBtn onClick={() => handlePlayPause()}>
                <CircularProgressBar 
                    angle={angle}
                    audio={audioRef.current}/>
            </PlayPauseBtn>}
        </Box>
    )
}

export default AudioModule